import crudApi from "../../../api/crudApi";
import listHandler from "../../../Domain/listHandler";
import InvitationConfig from "../Resources/Endpoints";

const withdrawInvitation = async (
  dataList,
  setDataList,
  invitation,
  groupId,
  index
) => {
  const deleteUrl = InvitationConfig.endpoints.withdraw + groupId + "/";

  listHandler.deleteFromList(
    index,
    crudApi.del(deleteUrl, +invitation.id),
    setDataList,
    dataList
  );
};

export { withdrawInvitation };
